import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import GlobalStyles from './styles/global';
import { Routes } from './routing/Routes';

const App = () => {
  return (
    <Router>
      <GlobalStyles />
      <Routes />
    </Router>
  );
};

export default App;
